<template>
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-check">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.7203 11.0766L1.4531 6.80941L0 8.25227L5.7203 13.9726L18 1.69287L16.5571 0.25L5.7203 11.0766Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: "IconCheck",
  props: {
    color: {
      type: String,
      default: '#E0E0E0'
    }
  }
}
</script>
